"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const TIME_FORMAT = "HH:mm";
const formatTime = (date) => (date_fns_1.format(date, TIME_FORMAT));
exports.default = formatTime;
